// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3ae2864d","239":"bb30d74a","732":"c2b349a3"}[chunkId] + ".chunk.js";
};